<template>
    <nav class="gnav nav-height">
        <ul class="sp-only gnav-menu">
            <el-button @click="drawer = true" class="btn-sub-menu"> <i class="fas fa-bars"></i> </el-button>
            <li class="sub-menu-buttom">
                <el-drawer
                    class="sub-menu-mb"
                    :visible.sync="drawer"
                    :with-header="false"
                    size="100%"
                    :modal="false"
                    :before-close="handleClose">
                    <div v-if="isAuthenticated">
                        <nav-login @close-nav="handleClose" :drawer="true"></nav-login>
                    </div>
                    <div v-else>
                        <nav-not-login @close-nav="handleClose" :drawer="true"></nav-not-login>
                    </div>
                </el-drawer>
            </li>
        </ul>
        <ul class="pc-only gnav-menu" v-if="isAuthenticated">
            <nav-login :drawer="false"></nav-login>
        </ul>
        <ul class="pc-only gnav-menu" v-else>
            <nav-not-login  :drawer="false"></nav-not-login>
        </ul>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import NavLogin from './NavLogin'
import NavNotLogin from './NavNotLogin'
export default {
  name: 'gnav',
    data () {
      return {
        ankenList: [],
        drawer: false
      }
    },
  computed: {
    ...mapGetters(['isAuthenticated', 'isMemberHasNewMessage'])
  },
   components: {
     'nav-login': NavLogin,
     'nav-not-login': NavNotLogin
   },
   methods: {
       handleClose () {
           this.drawer = false
       }
   }
}
</script>
<style>
    .notification-icon-container {
      display: inline-block;
      position: relative;
    }
    .nav-smart-phone li.first-child{
        text-align: right;
        background: #ede1c5 !important;
        position: relative;
        height: 40px;
    }
    .nav-smart-phone li.first-child i {
        font-weight: bold;
        color: #000000;
        padding-right: 10px;
        position: absolute;
        font-size: 24px;
        top: 10px;
        right: 0;
    }
</style>
